import React, { useEffect, useState, ReactNode } from "react";
import { Alert, Row, Col, Form, Label, UncontrolledTooltip } from "reactstrap";

import { Navbar, Nav, Container, Offcanvas, Button } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

// router
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";

import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { useSnackbar } from "../../utils/snackbar";

import topLogo from "../../assets/images/top-logo.webp";
import LanguageSwitcher from "../../components/LanguageSelector";
import { useTranslation } from "react-i18next";

export interface FaqItem {
  question: string;
  answer: ReactNode;
}

const Terms = () => {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const handleLogoClick = () => {
    navigate("/landing-page");
  };
  return (
    <div className="contact-us">
      <div className=" flex-grow-1">
        <Navbar expand="lg" className="px-3 pt-3">
          <Container fluid>
            {/* Left: Logo */}
            <Navbar.Brand
              onClick={handleLogoClick}
              style={{ cursor: "pointer" }}
            >
              <img
                src={topLogo}
                alt="Logo"
                width="160"
                height="40"
                className="d-inline-block align-center"
              />
            </Navbar.Brand>
            <span className="d-flex gap-3">
              <span className="d-block d-lg-none">
                <LanguageSwitcher />
              </span>
              <Navbar.Toggle
                aria-controls="offcanvasNavbar-expand"
                style={{ fontSize: "1rem", padding: "5px 7px" }}
              />
              <Navbar.Offcanvas
                id="offcanvasNavbar-expand"
                aria-labelledby="offcanvasNavbarLabel-expand"
                placement="end" // Right side
              >
                <Offcanvas.Header closeButton>
                  <Offcanvas.Title id="offcanvasNavbarLabel-expand">
                    {t("Menu")}
                  </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                  {/* Center-Right: Menu Items */}
                  <Nav className="ms-auto me-3">
                    <Button
                      className="rounded-pill py-1 d-none d-lg-block"
                      style={{
                        backgroundColor: "#ede7e7",
                        color: "gray",
                        borderColor: "#ede7e7",
                        paddingRight: "40px",
                        paddingLeft: "40px",
                      }}
                      onClick={() =>
                        window.open(
                          "https://www.gofundme.com/f/heroinvoice-die-faire-erechnungslosung-fur-kleinunternehm",
                          "_blank",
                        )
                      }
                    >
                      {t("Donate")}
                    </Button>
                    <Nav.Link as={Link} to="/about-us" className="contact-text">
                      {t("ABOUT US")}
                    </Nav.Link>
                    <Nav.Link
                      as={Link}
                      to="/learn-more"
                      className="contact-text"
                    >
                      {t("LEARN MORE")}
                    </Nav.Link>
                  </Nav>

                  {/* Right: Button */}

                  <Button
                    className="rounded-pill py-1 d-block d-lg-none my-3 w-100"
                    style={{
                      backgroundColor: "#ede7e7",
                      color: "gray",
                      borderColor: "#ede7e7",
                      paddingRight: "40px",
                      paddingLeft: "40px",
                    }}
                  >
                    {t("Donate")}
                  </Button>
                  <Button
                    className="rounded-pill px-3 py-1 d-none d-lg-block"
                    style={{ backgroundColor: "#1e587e", borderColor: "white" }}
                    onClick={() => {
                      navigate("/auth-register");
                    }}
                  >
                    {t("Try out for free")}
                  </Button>
                  <Button
                    className="rounded-pill px-3 py-1 w-100 d-block d-lg-none"
                    style={{ backgroundColor: "#1e587e", borderColor: "white" }}
                    onClick={() => {
                      navigate("/auth-register");
                    }}
                  >
                    {t("Try out for free")}
                  </Button>
                  <span className="d-none d-lg-block">
                    <LanguageSwitcher />
                  </span>
                </Offcanvas.Body>
              </Navbar.Offcanvas>
            </span>
          </Container>
        </Navbar>
        <Container className="learnmore-top px-4">
          <h1>{t("Terms and Conditions (T&C) of Hero-Invoice.com")}</h1>
          <div style={{ color: "gray" }}>
            <section id="section1" className="mt-30">
              <h4 className="mb-4">1. {t("Scope and Provider")}</h4>
              <p>
                {t(
                  "These Terms and Conditions apply to the use of the invoicing platform Hero-Invoice, operated by:",
                )}
              </p>
              <p className="mb-0 fw-bold">Tobias Krüger</p>
              <p className="mb-0 ">Frankenstraße 8</p>
              <p className="mb-0"> 92353 Postbauer-Heng</p>
              <p className="mb-0"> {t("Germany")}</p>
              <p className=""> Email: info@hero-invoice.com </p>
              <p>
                {t(
                  "Hero-Invoice is an online tool for creating invoices, quotes, estimates, and credit notes. The service is aimed at private individuals, freelancers, sole traders, and companies of all sizes – with a focus on small businesses and self-employed users.",
                )}
              </p>
              <p>{t("The contractual languages are German and English.")}</p>
            </section>

            <section id="section2" className="mt-30">
              <h4 className="mb-4">2. {t("Registration and Account")}</h4>
              <p>
                {t(
                  "To use Hero-Invoice, you must register for a free account. There is currently no subscription model, and you are not bound by any contract period. You can request account deletion at any time via the account settings.",
                )}
              </p>
              <p>
                {t(
                  "Hero-Invoice may be used by all persons legally allowed to issue invoices. There is no specific age restriction on our side.",
                )}
              </p>
            </section>

            <section id="section3" className="mt-30">
              <h4 className="mb-4">3. {t("Services and Functionality")}</h4>
              <p>
                {t(
                  "Hero-Invoice enables users to create various types of documents, including:",
                )}
              </p>
              <ul>
                <li>{t("Invoices")}</li>
                <li>{t("Credit notes")}</li>
                <li>{t("Quotes")}</li>
                <li>{t("Estimates")}</li>
              </ul>
              <p>
                {t(
                  "All documents are automatically generated based on the data you enter and can be exported as PDF or e-invoice. If you provide recipient email addresses, the documents can also be automatically emailed.",
                )}
              </p>
              <p>
                {t(
                  "The documents are suitable for tax purposes, but it is the user's responsibility to ensure their correct content and formal validity in accordance with local regulations.",
                )}
              </p>
            </section>

            <section id="section4" className="mt-30">
              <h4 className="mb-4">4. {t("Prices and Payment")}</h4>
              <p>
                {t(
                  "During the current open beta phase, all functions are completely free of charge",
                )}
                .
              </p>
              <p>
                {t(
                  "After the beta, Hero-Invoice will switch to a credit-based pricing model:",
                )}
              </p>
              <ul>
                <li>{t("The first 5 invoices per month will remain free.")}</li>
                <li>
                  {t(
                    "Each additional invoice will cost €0.10, payable through credit packs.",
                  )}
                </li>
                <li>
                  {t(
                    "Payment is handled securely via Stripe, including all supported payment methods.",
                  )}
                </li>
              </ul>
              <p>{t("There are no hidden fees or subscriptions.")}</p>
            </section>

            <section id="section5" className="mt-30">
              <h4 className="mb-4">5. {t("User Responsibilities")}</h4>
              <p>
                {t(
                  "Users are solely responsible for the correctness and legality of the data they enter into the system. Hero-Invoice merely provides the platform and does not verify or validate user-entered information.",
                )}
              </p>
              <p>
                {t(
                  "The use of Hero-Invoice for illegal or unethical activities (e.g., invoice fraud, phishing, resale of access) is strictly prohibited.",
                )}
              </p>
            </section>

            <section id="section6" className="mt-30">
              <h4 className="mb-4">6. {t("Liability and Warranty")}</h4>
              <p>
                {t(
                  "Hero-Invoice is provided 'as is' and 'as available.'' While we make every effort to ensure the stability and security of the platform, we:",
                )}
              </p>
              <p>
                {t(
                  "We are also not liable for damages resulting from the incorrect use of the service or reliance on the accuracy of generated documents.",
                )}
              </p>
              <ul>
                <li>{t("Do not guarantee uninterrupted availability,")}</li>
                <li>
                  {t(
                    "Do not guarantee that the service is error-free or suitable for any specific purpose,",
                  )}
                </li>
                <li>
                  {t(
                    "Do not accept liability for data loss, delays, or system outages...",
                  )}
                </li>
              </ul>
            </section>

            <section id="section7" className="mt-30">
              <h4 className="mb-4">7. {t("Support")}</h4>
              <p>
                {t("Support inquiries can be sent to info@hero-invoice.com.")}
              </p>
              <p>
                {t(
                  "We generally respond within 24 hours on business days, but there is no guaranteed response time.",
                )}
              </p>
            </section>

            <section id="section8" className="mt-30">
              <h4 className="mb-4">8. {t("Data Protection")}</h4>
              <p>
                {t("We take the protection of your personal data seriously.")}
              </p>
              <p>
                {t(
                  "Please refer to our separate Privacy Policy for details regarding data collection, processing, and your rights under the GDPR.",
                )}
              </p>
            </section>

            <section id="section9" className="mt-30">
              <h4 className="mb-4">9. {t("Termination and Data Retention")}</h4>
              <p>
                {t(
                  "There is no minimum contract duration. You may request the deletion of your account at any time.",
                )}
              </p>
              <p>
                {t(
                  "Upon deletion request, all personal data will be permanently and irreversibly deleted. It is the responsibility of the user to export any tax-relevant or important data beforehand. Hero-Invoice does not retain data for legal compliance on behalf of the user.",
                )}
              </p>
            </section>

            <section id="section10" className="mt-30">
              <h4 className="mb-4">
                10. {t("Governing Law and Jurisdiction")}
              </h4>
              <p>
                {t(
                  "These terms are governed by the laws of the Federal Republic of Germany.",
                )}
              </p>
              <p>
                {t(
                  "Where legally permissible, the place of jurisdiction is the provider’s registered office (Neumarkt i.d. OPf., Germany).",
                )}
              </p>
            </section>

            <section id="section11" className="mt-30">
              <h4 className="mb-4">11. {t("Severability Clause")}</h4>
              <p>
                {t(
                  "If any provision of these Terms and Conditions is or becomes invalid, the remaining provisions shall remain unaffected. The invalid clause shall be replaced by one that most closely reflects the original intent in a legally valid manner.",
                )}
              </p>
            </section>
          </div>
        </Container>
      </div>

      <div className="footer mt-4">
        <div className="footer-divider"></div>
        <Navbar expand="lg" className="px-3 pt-3">
          {/* Left: Logo */}
          <Navbar.Brand onClick={handleLogoClick} style={{ cursor: "pointer" }}>
            <img
              src={topLogo}
              alt="Logo"
              width="160"
              height="40"
              className="d-inline-block align-center"
            />
          </Navbar.Brand>

          {/* Center-Right: Menu Items */}
          <Nav className="ms-auto me-3">
            <Nav.Link as={Link} to="/imprint" className="text-gray">
              {t("Imprint")}
            </Nav.Link>
            <Nav.Link className="d-none d-lg-block">|</Nav.Link>
            <Nav.Link as={Link} to="/terms" className="text-gray">
              {t("Terms of Use")}
            </Nav.Link>
            <Nav.Link className="d-none d-lg-block">|</Nav.Link>
            <Nav.Link as={Link} to="/privacy" className="text-gray">
              {t("Privacy Policy")}
            </Nav.Link>
            <Nav.Link className="d-none d-lg-block">|</Nav.Link>
            <Nav.Link as={Link} to="/contact-us" className="text-gray">
              {t("Contact")}
            </Nav.Link>
          </Nav>
        </Navbar>
      </div>
    </div>
  );
};

export default Terms;
